import React, { useEffect, useState } from "react";
import "./signUp.scss";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import brandStore from "../../store/brandStore";
import authStore from "../../store/authStore";
import { LoadingButton } from "@mui/lab";
import snackbarStore from "../../store/snackbarStore";
import { BRAND_NAME_LOGO } from "../../constant";
import SEO from "components/seo/SEO";

const SignUp = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const BrandStore = brandStore();
  const AuthStore = authStore();
  const SnackbarStore = snackbarStore();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const onSignUp = async () => {
    let flag = 0;
    if (AuthStore.signUpForm.firstName === "") {
      AuthStore.setValidation({ name: "isFirstName", value: true });
      flag++;
    } else {
      AuthStore.setValidation({ name: "isFirstName", value: false });
    }
    if (AuthStore.signUpForm.lastName === "") {
      AuthStore.setValidation({ name: "isLastName", value: true });
      flag++;
    } else {
      AuthStore.setValidation({ name: "isLastName", value: false });
    }
    if (AuthStore.signUpForm.email === "") {
      AuthStore.setValidation({
        name: "emailMassage",
        value: "email address is require",
      });
      AuthStore.setValidation({ name: "isEmail", value: true });
      flag++;
    } else {
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (reg.test(AuthStore.signUpForm.email) === true) {
        AuthStore.setValidation({ name: "isEmail", value: false });
      } else {
        AuthStore.setValidation({
          name: "emailMassage",
          value: "email address is wrong",
        });
        AuthStore.setValidation({ name: "isEmail", value: true });
        flag++;
      }
    }
    if (AuthStore.signUpForm.phoneNumber === "") {
      AuthStore.setValidation({
        name: "phoneNumberMassage",
        value: "phone no is require",
      });
      AuthStore.setValidation({ name: "isPhoneNumber", value: true });
      flag++;
    } else {
      if (AuthStore.signUpForm.phoneNumber.length === 10) {
        AuthStore.setValidation({ name: "isPhoneNumber", value: false });
      } else {
        AuthStore.setValidation({
          name: "phoneNumberMassage",
          value: "phone no must be 10  digit",
        });
        AuthStore.setValidation({ name: "isPhoneNumber", value: true });
        flag++;
      }
    }
    if (AuthStore.signUpForm.password === "") {
      AuthStore.setValidation({
        name: "passwordMassage",
        value: "password is require",
      });
      AuthStore.setValidation({ name: "isPassword", value: true });
      flag++;
    } else {
      if (
        AuthStore.signUpForm.password.length < 8 ||
        AuthStore.signUpForm.password.length > 13
      ) {
        AuthStore.setValidation({
          name: "passwordMassage",
          value: "password must be 8 - 13",
        });
        AuthStore.setValidation({ name: "isPassword", value: true });
        flag++;
      } else {
        AuthStore.setValidation({ name: "isPassword", value: false });
      }
    }

    if (flag !== 0) {
      return false;
    }
    setIsLoading(true);
    // const res = await AuthStore.signUp();
    const res = await AuthStore.emailIsExists();
    setIsLoading(false);
    if (res) {
      // SnackbarStore.setMassage({ value: "Sign Up Successfully" });
      navigate("/verification");
    }
  };

  return (
    <Grid
      container
      component="main"
      className="sing-up"
      sx={{ p: isNonMobile ? "50px" : "10px" }}
    >
      <SEO
        title="Sign Up | KRISTIVE"
        description="Join KRISTIVE and unlock exclusive benefits. Create your account to shop luxury fragrances, track orders, and enjoy a personalized experience."
      />
      <Container component="main" maxWidth="sm">
        <Box component="div" className="container">
          <Box component="div" className="brand-name-logo-container">
            <Link to={"/"} component="div" className="brand-name-logo">
              <img src={BRAND_NAME_LOGO} alt="brand-logo" />
            </Link>
          </Box>

          <Typography component="h1" variant="h5" className="title">
            Sign Up
          </Typography>
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="firstName"
                  name="firstName"
                  type="text"
                  required
                  fullWidth
                  label="First Name"
                  autoComplete="given-name"
                  autoFocus
                  error={AuthStore.signUpFormValidation.isFirstName}
                  helperText={
                    AuthStore.signUpFormValidation.isFirstName &&
                    "first name is require"
                  }
                  value={AuthStore.signUpForm.firstName}
                  onChange={AuthStore.fillSignUpForm}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="lastName"
                  name="lastName"
                  type="text"
                  required
                  fullWidth
                  label="Last Name"
                  autoComplete="family-name"
                  error={AuthStore.signUpFormValidation.isLastName}
                  helperText={
                    AuthStore.signUpFormValidation.isLastName &&
                    "last name is require"
                  }
                  value={AuthStore.signUpForm.lastName}
                  onChange={AuthStore.fillSignUpForm}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  required
                  fullWidth
                  label="Email Address"
                  autoComplete="email"
                  error={AuthStore.signUpFormValidation.isEmail}
                  helperText={
                    AuthStore.signUpFormValidation.isEmail &&
                    AuthStore.signUpFormValidation.emailMassage
                  }
                  value={AuthStore.signUpForm.email}
                  onChange={AuthStore.fillSignUpForm}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="phoneNumber"
                  name="phoneNumber"
                  inputProps={{ inputMode: "numeric", maxLength: 10 }}
                  required
                  fullWidth
                  label="Phone No"
                  autoComplete="phone"
                  error={AuthStore.signUpFormValidation.isPhoneNumber}
                  helperText={
                    AuthStore.signUpFormValidation.isPhoneNumber &&
                    AuthStore.signUpFormValidation.phoneNumberMassage
                  }
                  value={AuthStore.signUpForm.phoneNumber}
                  onChange={AuthStore.fillSignUpForm}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="password"
                  name="password"
                  type="password"
                  required
                  fullWidth
                  label="Set new Password"
                  autoComplete="new-password"
                  error={AuthStore.signUpFormValidation.isPassword}
                  helperText={
                    AuthStore.signUpFormValidation.isPassword &&
                    AuthStore.signUpFormValidation.passwordMassage
                  }
                  value={AuthStore.signUpForm.password}
                  onChange={AuthStore.fillSignUpForm}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox value="allowExtraEmails" color="primary" />
                  }
                  label={
                    <p>
                      I want to receive inspiration, marketing promotions and
                      updates via email.
                    </p>
                  }
                />
              </Grid>
            </Grid>
            <LoadingButton
              loading={isLoading}
              type="button"
              fullWidth
              variant="contained"
              className="btn"
              onClick={onSignUp}
            >
              Sign Up
            </LoadingButton>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link to="/sign-in">
                  <Typography variant="body2" className="go-to-sign-in link">
                    Already Have an account? Sign In
                  </Typography>
                </Link>
              </Grid>
            </Grid>
            <Typography
              variant="body2"
              color="text.secondary"
              align="center"
              className="copy-right"
            >
              Copyright © {currentYear} {BrandStore.brand.brandName}. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Grid>
  );
};

export default SignUp;
